<template lang="pug">
  #MySa
    .bound.text-center(
      v-if='saData.personnel'
    )
      p.title.mb-3.font-weight-bolder 您的服務顧問
        .head-img.mt-6.mb-2
          img(
            :src="saData.personnel.picture_url",
            :onerror="defaultPhotoSticker"
          )
      h4.font-weight-bold.mb-2 {{ saData.personnel.chinese_last_name }}{{ saData.personnel.chinese_first_name }}
      p.mb-3
        i.fas.fa-map-marker-alt.mr-2
        span(
          variant="primary",
          v-for="store in saData.personnel.stores",
          :key="store.id",
          class="py-2 m-1"
        ) {{ store.title }}

        .col-10.m-auto
           b-button.btn-primary(
              variant="primary",
              block,
              @click="sendMessage()"
            ) 與服務顧問一對一
    //- .row.p-3.pt-5.mx-2
    //-   .col-6
    //-     b-button(
    //-       variant="primary",
    //-       block,
    //-       @click="unbindHandler()"
    //-     ) 解除綁定
    //-   .col-6
    //-     b-button(
    //-       variant="primary",
    //-       block,
    //-       @click="backToLINEHandler()"
    //-     ) 與顧問一對一
    

</template>

<script>
import { mapState } from 'vuex';
import { M_UNBIND_SUCCESS } from '@/router/member/my-sa';
import { M_UNBIND } from '@/router/member/my-sa';
import defaultPhotoStickerUrl from '@/assets/images/default/defaultProfileImg.png';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'MySaIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('member_my_sa/getSaProfileHandler',)
      .then(() => {
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
        if(this.saData.action == 'to-bind-page' ){
          vm.$router.push({
                name: M_UNBIND
              });
        }
      });
  },
  methods: {
    unbindHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '您確定解除與顧問的綁定?',
        text: '解除後需重新綁定方可使用一對一服務！',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'custom-swal-btn',
          cancelButton: 'custom-swal-btn'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '解除綁定中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          // 解除綁定
          vm.$store.dispatch('member_my_sa/unbindSaHandler')
            .then(() => {
              vm.$swal.close();
              vm.$router.push({
                name: M_UNBIND_SUCCESS
              });
            });
        }
      });
    },
    sendMessage() {
      const vm = this;
      // 傳送開啟聊天室flex-message
          vm.$store.dispatch('member_my_sa/activateKeywordHandler')
            .then(() => {
              window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
            });
    }
  },
  computed: {
    ...mapState({
      saData: (state) => state.member_my_sa.saData
    })
  }
};
</script>

<style lang="scss" scoped>
.bound {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.title {
  font-size: 1.5rem;
  position: relative;
    &:before, &:after{
    position: absolute;
    content: "";
    width: 1px;
    height: 120%;
    background-color: #000;
    top: 0;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    }
    &:before{
     left: 2rem;
      -webkit-transform: rotate(-20deg);
      transform: rotate(-20deg);
    }
    &:after{
      right: 2rem;
      -webkit-transform: rotate(20deg);
      transform: rotate(20deg);
    }
}
.head-img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #bababa;
  }
img {
  width: 100%;
  height: 100%;
  object-fit: cover;}
.btn-primary {
  background-color: #ffe19f;
  border-color: #ffe19f;
}
.rounded-circle {
  border-radius: unset!important;
}
</style>
